import { useEffect, useState } from 'react';

// The Outline page unmounts this message when the writer leaves. The choice
// to use a Framework's sequences can only be undone from here, and the
// message has no clock: it stays until Undo or dismiss.
let current = null;
const listeners = new Set();

function emit() {
  listeners.forEach((fn) => fn(current));
}

export function publishFrameworkUndo(next) {
  current = next || null;
  emit();
}

export function resetFrameworkUndo() {
  current = null;
  emit();
}

export function useFrameworkUndo() {
  const [value, setValue] = useState(current);
  useEffect(() => {
    listeners.add(setValue);
    setValue(current);
    return () => listeners.delete(setValue);
  }, []);
  return value;
}
